var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"shell-header-top no-banner"}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v("Messages")]),_vm._v(" "),_c('conversation-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }